/**
 * The operation when using a catalogue.
 */
export enum CatalogueOperation {
  Create = 1,
  Edit = 2,
}
